export default __webpack_public_path__ + "static/media/printer.233f45e3.svg";